import PropTypes from "prop-types";
import {
  HiOutlineDocumentText,
  HiOutlineCheckCircle,
  HiOutlineCurrencyDollar,
  HiOutlineExclamationCircle,
} from "react-icons/hi2";
import { useBulkSummation } from "../hooks/useBulkSummation";
import BulkStatCard from "./cards/BulkStatCard";
import { formatKES, getDisplayValue } from "../../../utils/transactionutils";

const CARD_CONFIGS = [
  {
    key: "pendingBatches",
    icon: <HiOutlineDocumentText className="text-warning-600" />,
    iconBgClass: "bg-warning-50",
    label: "Pending Batches",
    errorMessage: "Failed to load pending batches.",
    getValue: (d) => getDisplayValue(d.pendingBatches),
  },
  {
    key: "completedToDay",
    icon: <HiOutlineCheckCircle className="text-success-600" />,
    iconBgClass: "bg-success-50",
    label: "Completed Today",
    errorMessage: "Failed to load completed batches.",
    getValue: (d) => getDisplayValue(d.completedToDay),
  },
  {
    key: "totalVolume",
    icon: <HiOutlineCurrencyDollar className="text-primary-600" />,
    iconBgClass: "bg-primary-50",
    label: "Total Volume",
    errorMessage: "Failed to load total volume.",
    getValue: (d) => formatKES(d.totalVolume),
  },
  {
    key: "failedUploads",
    icon: <HiOutlineExclamationCircle className="text-error-600" />,
    iconBgClass: "bg-error-50",
    metricText: "Action Required",
    metricColorClass: "text-error-600 font-semibold",
    label: "Failed Payments",
    errorMessage: "Failed to load failed payments.",
    getValue: (d) => getDisplayValue(d.failedUploads),
  },
];

export default function BulkUploadsStats({ isSuperAdmin = false }) {
  const { totalVolume, pendingBatches, completedToDay, failedUploads, isLoading, isError, refetch } =
    useBulkSummation(isSuperAdmin);

  const data = { totalVolume, pendingBatches, completedToDay, failedUploads };

  return (
    <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
      {CARD_CONFIGS.map(({ key, getValue, ...cardProps }) => (
        <BulkStatCard
          key={key}
          {...cardProps}
          value={getValue(data)}
          isLoading={isLoading}
          isError={isError}
          onRetry={refetch}
        />
      ))}
    </div>
  );
}

BulkUploadsStats.propTypes = {
  isSuperAdmin: PropTypes.bool,
};
